// @flow
import type { Periodicity } from 'digicel-kaizen-library';
import I18n from './i18n';

export default (periodicity: Periodicity): string => {
  if (!periodicity?.number || !periodicity.type) return '';

  let finalPeriodicity = periodicity;
  if (periodicity.type === 'DAY' && periodicity.number === 30) {
    finalPeriodicity = {
      type: 'MONTH',
      number: 1,
    };
  }

  return I18n.t(`periodicity.${finalPeriodicity.type}`, { count: finalPeriodicity.number });
};
